<div class="container main-router-outlet" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    *ngIf="showLessonPlanSpinner"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    [zIndex]="3000"
  >
  </ngx-spinner>
  <div class="row header-content m-0" [ngClass]="newLessonPlan ? 'pb-3' : ''">
    <div class="col-md-12 d-flex justify-content-between header-content-items">
      <div>
        <nb-icon
          icon="arrow-back"
          class="btn-back cursor-pointer"
          (click)="
            !storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
            !storageService.checkUserRole(user?.user?.role_id, 'teacher_only') ||
            pushLessonPlan
              ? back()
              : !lessonPlan
              ? deleteLessonPlanDialog(save)
              : addLessonPlanForm.dirty || isValidSources
              ? deleteLessonPlanDialog(save)
              : back()
          "
        >
        </nb-icon>
      </div>

      <div class="form-group timer-section quicksand-bold-label text-center">
        <div class="from-time-end-time" *ngIf="addLessonPlanForm.value.start && addLessonPlanForm.value.end && lessonPlan">
          {{ addLessonPlanForm.value.start | date : 'h:mm a' }}
          -
          {{ addLessonPlanForm.value.end | date : 'h:mm a' }}
        </div>

        <div class="from-time-end-time mt-2" *ngIf="lessonPlan">
          <div *ngIf="isCounter">
            <span> {{ remainingTime?.$d.days }} d : </span>
            <span> {{ remainingTime?.$d.hours }} h : </span>

            <span> {{ remainingTime?.$d.minutes }} m : </span>

            <span> {{ remainingTime?.$d.seconds }} s </span>
            Remaining
          </div>

          <div *ngIf="!isCounter" class="time-passed-label">Time Has passed</div>
        </div>
      </div>

      <div
        *ngIf="
          !storageService.checkUserRole(user?.user?.role_id, 'teacher') &&
          !storageService.checkUserRole(user?.user?.role_id, 'teacher_only')
        "
      >
        <button class="generate-pdf quicksand-bold-label text-capitalize" nbButton (click)="makePdf()">Generate PDF</button>
      </div>

      <div
        class="action-content"
        *ngIf="
          storageService.checkUserRole(user?.user?.role_id, 'teacher') || storageService.checkUserRole(user?.user?.role_id, 'teacher_only')
        "
      >
        <button
          class="generate-pdf quicksand-bold-label text-capitalize  {{ currentLessonPlan?.user_id ? '' : 'mr-2' }}"
          nbButton
          (click)="makePdf()"
        >
          Generate PDF
        </button>
        <button
          nbButton
          *ngIf="lessonPlan && !isStudent"
          (click)="openLessonPlanPrivacyDialog()"
          class="set-lesson-plan quicksand-bold-label ml-2"
        >
          Update
        </button>

        <span class="delete-pacing-plans ml-3 cursor-pointer" (click)="openLessonPlanDialog(dialog, true)" *ngIf="lessonPlan && !isStudent">
          <img src="/assets/icons/delete.svg" alt="delete-icon" height="20" width="20" />
        </span>

        <button
          class="save-lesson-plan quicksand-bold-label"
          nbButton
          (click)="generateNewVersionLessonPlan()"
          *ngIf="!lessonPlan && !pushLessonPlan"
        >
          Save
        </button>

        <button class="save-lesson-plan quicksand-bold-label" nbButton (click)="createPacingPlanAndPush()" *ngIf="pushLessonPlan">
          Save And Push
        </button>
      </div>
    </div>

    <div class="col-md-12 mb-4" *ngIf="lessonPlan && averagePercentage >= 0 && isCounter">
      <div class="row">
        <div class="col-md-11 col-sm-11 pt-1">
          <nb-progress-bar
            [value]="averagePercentage"
            [status]="
              averagePercentage >= 0 && averagePercentage <= 50
                ? 'success'
                : averagePercentage >= 50 && averagePercentage <= 75
                ? 'warning'
                : 'danger'
            "
          ></nb-progress-bar>
        </div>
        <div class="col-md-1 col-sm-1">
          <span class="quicksand-bold-label">{{ averagePercentage }} %</span>
        </div>
      </div>
    </div>
  </div>
  <hr />

  <div class="row">
    <div class="col-md-12">
      <form [formGroup]="addLessonPlanForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="label form-control-label">Grade</label>
              <input type="text" class="nb-input" matInput fullWidth formControlName="grade" readonly="true" placeholder="Grade" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="label form-control-label">Subject</label>
              <input type="text" class="nb-input" matInput fullWidth formControlName="subject" readonly="true" placeholder="Subject" />
            </div>
          </div>
        </div>

        <nb-card>
          <nb-card-header class="card-border-radius">Info</nb-card-header>
          <nb-card-body>
            <div class="form-group mt-3" *ngIf="addLessonPlanForm.value.sectionId">
              <label class="label form-control-label">Section ID</label>
              <textarea
                type="text"
                class="nb-input"
                matInput
                fullWidth
                formControlName="sectionId"
                readonly="true"
                placeholder="Section Id"
                [readOnly]="true"
              ></textarea>
            </div>
            <div class="form-group">
              <label class="label form-control-label">Section Title</label>
              <textarea
                type="text"
                class="nb-input"
                matInput
                fullWidth
                formControlName="sectionTitle"
                readonly="true"
                placeholder="Section Title"
                [readOnly]="true"
              ></textarea>
            </div>

            <div class="form-group">
              <label class="label form-control-label">Objective</label> <br />
              <textarea
                formControlName="objective"
                matInput
                class="w-100 text-area"
                placeholder="Objective"
                [readOnly]="isStudent"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
              ></textarea>
              <!-- ngxTextareaAutoresize -->
            </div>

            <div class="form-group">
              <label class="label form-control-label">Anticipatory Set</label>
              <br />
              <textarea
                formControlName="anticipatory_set"
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                placeholder="Anticipatory Set"
                class="w-100 text-area"
                [readOnly]="isStudent"
              ></textarea>
              <!-- ngxTextareaAutoresize -->
            </div>
          </nb-card-body>
        </nb-card>

        <nb-accordion
          *ngIf="currentLessonPlan?.subject_id === 15 || currentLessonPlan?.subject_id === 24"
          class="mt-1 lesson-plan-accordion"
        >
          <nb-accordion-item>
            <nb-accordion-item-header class="quicksand-bold-label"> Base your lesson on a short story or novel </nb-accordion-item-header>
            <nb-accordion-item-body>
              <form [formGroup]="lessonPlanForm">
                <div class="{{ storageService.detectMob() ? '' : 'row' }} novel-form">
                  <div class="form-group {{ storageService.detectMob() ? '' : 'col-6' }}">
                    <label class="label form-control-label">Title <span class="required-field">*</span></label>
                    <br />
                    <input type="text" nbInput fullWidth placeholder="Enter the title of the story" formControlName="title" />
                    <br />
                    <div class="pl-3">
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                          lessonPlanForm.controls.title.invalid &&
                          (lessonPlanForm.controls.title.dirty || lessonPlanForm.controls.title.touched)
                        "
                        >Enter Your Valid Title</label
                      >
                    </div>
                  </div>

                  <div class="form-group {{ storageService.detectMob() ? '' : 'col-6' }}">
                    <label class="label form-control-label">Author <span class="required-field">*</span></label>
                    <br />
                    <input type="text" nbInput fullWidth placeholder="Enter the name of the author" formControlName="author" />
                    <div class="pl-3">
                      <label
                        class="quicksand-bold-label error-label"
                        *ngIf="
                          lessonPlanForm.controls.author.invalid &&
                          (lessonPlanForm.controls.author.dirty || lessonPlanForm.controls.author.touched)
                        "
                        >Enter Your Valid Author</label
                      >
                    </div>
                  </div>

                  <div class="form-group {{ storageService.detectMob() ? '' : 'col-6' }}">
                    <label class="label form-control-label">Chapter or Section Number (Optional)</label>
                    <br />
                    <input type="text" nbInput fullWidth placeholder="Chapter or Section #" formControlName="chapter" />
                  </div>
                  <div class="form-group {{ storageService.detectMob() ? '' : 'col-6' }}">
                    <button class="header-buttons-guided-practice save-lesson-type" nbButton (click)="generateLessonPlan()">
                      Generate New Lesson
                    </button>
                  </div>
                </div>
              </form>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>

        <nb-card>
          <nb-card-header class="{{ isMobileScreen ? '' : 'd-flex justify-content-between' }} card-border-radius">
            <div class="align-self-center">Presentation</div>
            <ng-container
              *ngIf="
                (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                !isStudent
              "
            >
              <div class="d-flex presention">
                <div class="quicksand-normal-label mx-2 align-self-center">Edit manually or auto-generate a new presentation with AI!</div>
                <button
                  class="{{ isMobileScreen ? 'ml-0 mt-2' : 'float-right ml-2' }} header-buttons"
                  nbButton
                  [matMenuTriggerFor]="matmenu"
                >
                  <img src="/assets/icons/edit-faded.svg" alt="edit" height="17" width="17" class="mr-1" />
                  Edit
                </button>
                <button
                  class="{{ isMobileScreen ? 'ml-0 mt-2 mr-2' : 'float-right ml-2' }} header-buttons"
                  nbButton
                  (click)="addRankToLessonPlan()"
                >
                  <img src="/assets/icons/thumb-faded.svg" alt="edit" height="17" width="17" class="mr-1" *ngIf="!isRanked" />

                  <img src="/assets/icons/thumb-dark.svg" alt="edit" height="17" width="17" class="mr-1" *ngIf="isRanked" />
                  Like
                </button>
              </div>
            </ng-container>
            <mat-menu #matmenu="matMenu">
              <button mat-menu-item (click)="isDisabledPresentation = false; highlightPresentation = true; isEditing = true">
                <span class="quicksand-bold-label">Edit</span>
              </button>
              <hr class="m-0" />
              <button mat-menu-item (click)="addNewPresentation()">
                <span class="quicksand-bold-label">Add New Presentation</span>
              </button>
            </mat-menu>
          </nb-card-header>
          <nb-card-body>
            <div *ngIf="!isEditing; else editPresentation">
              <div
                class="math-output"
                contenteditable="true"
                [mathjax]="getFormattedAnswer('presentation')"
                (input)="isEditing = true"
              ></div>
            </div>

            <ng-template #editPresentation>
              <textarea
                formControlName="presentation"
                matInput
                placeholder="Presentation"
                cdkTextareaAutosize
                class="w-100 text-area text-area-lg text-animation"
                [ngClass]="{ 'highlight-textarea': highlightPresentation }"
                [readOnly]="isDisabledPresentation"
              ></textarea>
            </ng-template>
          </nb-card-body>
        </nb-card>

        <nb-card>
          <nb-card-header class="card-border-radius">
            Presentation Source

            <ng-container
              *ngIf="
                (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                !isStudent
              "
            >
              <button
                *ngIf="videoUrls.length > 0 || lessonPlanMedia"
                class="float-right header-buttons-guided-practice header-buttons-presentation-source {{
                  storageService.detectMob() ? 'mx-1' : 'ml-2'
                }}"
                nbButton
                (click)="addPresentationSource()"
              >
                <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
                Add Presentation Source
              </button>
            </ng-container>
          </nb-card-header>
          <nb-card-body>
            <nb-tabset *ngIf="videoUrls.length > 0 || lessonPlanMedia" class="presentation-source-tab-set">
              <nb-tab tabTitle="YouTube" class="tab-title">

                <app-you-tube-player 
                  [videoUrls]="videoUrls"
                  [height]="300"
                  [showDeleteButton]="(storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                            storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                          !isStudent"
                  (deleteVideo)="deleteYouTubeSourceUrls($event)">
                </app-you-tube-player>

              </nb-tab>
              <nb-tab tabTitle="Documents" class="tab-title">
                <div class="row mt-3" *ngIf="lessonPlanMedia && lessonPlanMedia?.id">
                  <ngx-doc-viewer
                    [url]="lessonPlanMedia?.media?.url"
                    [viewer]="
                      lessonPlanMedia?.media?.name.includes('.doc') || lessonPlanMedia?.media?.name.includes('.pdf') ? 'url' : 'google'
                    "
                    style="width: 100%; height: 50vh; margin: 20px"
                  ></ngx-doc-viewer>

                  <div class="d-flex justify-content-between m-3 w-100">
                    <label class="you-tube-title">{{ lessonPlanMedia?.media?.name }}</label>

                    <img
                      src="/assets/icons/delete.svg"
                      alt="delete-icon"
                      height="20"
                      width="20"
                      (click)="deleteLessonPlanMedia(); isValidSources = true"
                      class="cursor-pointer"
                      *ngIf="
                        (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                          storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                        !isStudent
                      "
                    />
                  </div>
                </div>
                <div class="mt-3 quicksand-bold-label text-center" *ngIf="!lessonPlanMedia && !lessonPlanMedia?.id">
                  <img src="/assets/images/respond-edu.svg" alt="responed-edu" height="100" width="100" />
                  <br />
                  No Presentation Document Found!
                </div>
              </nb-tab>
            </nb-tabset>

            <div
              class="no-presentation-found text-center"
              *ngIf="
                (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                videoUrls?.length === 0 &&
                !lessonPlanMedia &&
                !isStudent
              "
            >
              <button
                class="header-buttons-guided-practice header-buttons-presentation-source  {{
                  storageService.detectMob() ? 'mx-1' : 'ml-2'
                }}"
                nbButton
                (click)="addPresentationSource()"
                *ngIf="
                  storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')
                "
              >
                <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
                Add Presentation Source
              </button>
            </div>

            <h6
              class="text-center quicksand-bold-label"
              *ngIf="
                !storageService.checkUserRole(user?.user?.role_id, 'teacher') &&
                !storageService.checkUserRole(user?.user?.role_id, 'teacher_only') &&
                videoUrls?.length === 0
              "
            >
              No Presentation Source Found!
            </h6>
          </nb-card-body>
        </nb-card>

        <nb-card>
          <nb-card-header class="card-border-radius">
            Guided Practice Questions

            <ng-container
              *ngIf="
                (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                !isStudent &&
                !isMobileScreen
              "
              ><button
                class="float-right header-buttons-guided-practice ml-2"
                nbButton
                (click)="addPracticeQuestions('easy')"
                *ngIf="!addLessonPlanForm.value.easyQuestions"
              >
                <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
                5 Easy Questions
              </button>

              <button
                class="float-right header-buttons-guided-practice"
                nbButton
                (click)="addPracticeQuestions('difficult')"
                *ngIf="!addLessonPlanForm.value.difficultQuestions"
              >
                <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
                5 Difficult Questions
              </button>
              <label
                class="add-questions-label quicksand-bold-label float-right"
                *ngIf="!addLessonPlanForm.value.easyQuestions || !addLessonPlanForm.value.difficultQuestions"
                >ADD:</label
              ></ng-container
            >
            <ng-container
              *ngIf="
                (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                !isStudent &&
                isMobileScreen
              "
            >
              <div class="row mt-2 px-3">
                <label
                  class="add-questions-label quicksand-bold-label"
                  *ngIf="!addLessonPlanForm.value.easyQuestions || !addLessonPlanForm.value.difficultQuestions"
                  >ADD:</label
                >
                <div class="ml-auto">
                  <button
                    class="header-buttons-guided-practice ml-2 float-right"
                    nbButton
                    (click)="addPracticeQuestions('easy')"
                    *ngIf="!addLessonPlanForm.value.easyQuestions"
                  >
                    <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
                    5 Easy Questions
                  </button>

                  <button
                    class="header-buttons-guided-practice float-right"
                    nbButton
                    (click)="addPracticeQuestions('difficult')"
                    *ngIf="!addLessonPlanForm.value.difficultQuestions"
                  >
                    <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
                    5 Difficult Questions
                  </button>
                </div>
              </div>
            </ng-container>
          </nb-card-header>
          <nb-card-body ngxTextareaAutoresize>
            <div *ngIf="!isEditing; else editGuidedQuestionsMode">
              <div
                class="math-output"
                contenteditable="true"
                [mathjax]="getFormattedAnswer('guided_practice_questions')"
                (input)="isEditing = true"
              ></div>
            </div>

            <ng-template #editGuidedQuestionsMode>
              <textarea
                formControlName="guided_practice_questions"
                matInput
                placeholder="Guided Practice Questions"
                class="w-100 text-area text-area-lg"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                [readOnly]="isStudent"
              ></textarea>
            </ng-template>

            <div class="form-group m-0" *ngIf="addLessonPlanForm.value.easyQuestions && addLessonPlanForm.value.easyQuestions !== ''">
              <label class="label form-control-label">Easy Questions</label>
              <br />

              <div *ngIf="!isEditing; else editEasyQuestionMode">
                <div
                  class="math-output"
                  contenteditable="true"
                  [mathjax]="getFormattedAnswer('easyQuestions')"
                  (input)="isEditing = true"
                ></div>
              </div>

              <ng-template #editEasyQuestionMode>
                <textarea
                  formControlName="easyQuestions"
                  matInput
                  placeholder="Easy Questions"
                  class="w-100 text-area text-area-lg"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  [readOnly]="isStudent"
                ></textarea>
              </ng-template>
            </div>

            <div class="form-group" *ngIf="addLessonPlanForm.value.difficultQuestions && addLessonPlanForm.value.difficultQuestions !== ''">
              <label class="label form-control-label">Difficult Questions</label>
              <br />
              <div *ngIf="!isEditing; else editDifficultQuestionMode">
                <div
                  class="math-output"
                  contenteditable="true"
                  [mathjax]="getFormattedAnswer('difficultQuestions')"
                  (input)="isEditing = true"
                ></div>
              </div>

              <ng-template #editDifficultQuestionMode>
                <textarea
                  formControlName="difficultQuestions"
                  matInput
                  placeholder="Difficult Questions"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  class="w-100 text-area text-area-lg"
                  [readOnly]="isStudent"
                ></textarea>
              </ng-template>
              <!-- ngxTextareaAutoresize -->
            </div>
          </nb-card-body>
        </nb-card>

        <nb-card>
          <nb-card-header class="card-border-radius">
            Homework Questions

            <button
              class="float-right header-button-homework-question quicksand-bold-label"
              nbButton
              (click)="createNewAssignment(save)"
              *ngIf="
                (storageService.checkUserRole(user?.user?.role_id, 'teacher') ||
                  storageService.checkUserRole(user?.user?.role_id, 'teacher_only')) &&
                !isStudent &&
                !pushLessonPlan
              "
            >
              <nb-icon icon="plus" class="plus-icon m-0"></nb-icon>
              Create Assignment
            </button>
          </nb-card-header>
          <nb-card-body ngxTextareaAutoresize>
            <div *ngIf="!isEditing; else editHomeworkQuestionMode">
              <div
                class="math-output"
                contenteditable="true"
                [mathjax]="getFormattedAnswer('homework_questions', false)"
                (input)="isEditing = true"
              ></div>
            </div>

            <ng-template #editHomeworkQuestionMode>
              <textarea
                formControlName="homework_questions"
                matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                placeholder="Homework Question"
                class="w-100 text-area text-area-lg"
                [readOnly]="isStudent"
              ></textarea>
            </ng-template>
          </nb-card-body>
        </nb-card>

        <nb-card>
          <nb-card-header class="card-border-radius"> Closure </nb-card-header>
          <nb-card-body>
            <textarea
              formControlName="closure"
              matInput
              placeholder="Closure"
              class="w-100 text-area text-area-lg"
              [readOnly]="isStudent"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
            ></textarea>
            <!-- ngxTextareaAutoresize -->
          </nb-card-body>
        </nb-card>
      </form>
    </div>
  </div>
</div>

<ng-template #dialog let-data let-ref="dialogRef">
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <nb-card>
      <nb-card-body>
        <div class="text-center">
          <img src="/assets/icons/featured icon.svg" alt="delete-icon" loading="lazy" />
          <br />

          <label f class="label-delete-lesson-plan quicksand-bold-label mt-1">Delete Lesson Plan</label>
          <br />
          <label class="delete-lesson-plan-confirmation quicksand-normal-label">Are you sure want to delete this lesson plan ?</label>
        </div>
        <div class="d-flex">
          <button nbButton class="cancel bg-white m-2 w-100 quicksand-bold-label" (click)="ref.close()">Cancel</button>
          <button nbButton color="warn" class="delete-lesson-plan delete m-2 w-100 quicksand-bold-label" (click)="deleteLessonPlan()">
            Delete
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>

<ng-template #newLessonPlanContent let-data let-ref="dialogRef">
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <nb-card>
      <nb-card-body>
        <div class="text-center">
          <img src="/assets/icons/save-featured-icon.svg" alt="delete-icon" loading="lazy" />
          <br />

          <label f class="label-delete-lesson-plan quicksand-bold-label mt-1"
            ><span *ngIf="user?.user?.is_trial_user ? true : currentClassroom?.user_id === user.user.id">You</span>
            <span *ngIf="!user?.user?.is_trial_user && currentClassroom?.user_id !== user.user.id">Teacher</span>
            have already created lesson plan <br />
            for this day, If you want to continue with this, existing <br />
            lesson plan will get deleted!</label
          >
          <br />
          <label class="delete-lesson-plan-confirmation quicksand-normal-label"
            >Are you sure you want to continue with this lesson plan ?</label
          >
        </div>
        <div class="d-flex">
          <button nbButton class="cancel bg-white m-2 w-100 quicksand-bold-label" (click)="ref.close(); back()">Cancel</button>
          <button nbButton color="warn" class="save-changes-btn m-2 w-100 quicksand-bold-label" (click)="deleteLessonPlanAndRender()">
            Yes
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>

<ng-template #save let-data let-ref="dialogRef">
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <nb-card>
      <nb-card-body>
        <div class="text-center">
          <img src="/assets/icons/save-featured-icon.svg" alt="delete-icon" loading="lazy" />
          <br />

          <label f class="label-delete-lesson-plan quicksand-bold-label mt-1"
            ><span *ngIf="isSave"> Unsaved Changes </span>

            <span *ngIf="!isSave">Do you want to create assignment ?</span></label
          >
          <br />
          <label class="delete-lesson-plan-confirmation quicksand-normal-label"
            ><span *ngIf="isSave"> Do you want to save or discard changes? </span>
            <span *ngIf="!isSave"> Lesson plan will get updated if you changed something? </span>
          </label>
        </div>
        <div class="d-flex">
          <button nbButton class="cancel bg-white m-2 w-100 quicksand-bold-label" (click)="ref.close(); isSave ? back() : null">
            Cancel
          </button>
          <button
            nbButton
            color="warn"
            class="save-changes-btn m-2 w-100 quicksand-bold-label"
            (click)="
              ref.close(); isSave ? (!lessonPlan ? generateNewVersionLessonPlan() : openLessonPlanPrivacyDialog()) : createNewAssignment()
            "
          >
            Save <span *ngIf="isSave" class="ml-1">Changes</span>
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>

<ng-template #callAPIDialog>
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <ngx-spinner
      template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
      [showSpinner]="loading"
      size="small"
      [disableAnimation]="false"
      color="white"
      bdColor="rgba(0,0,0,0.5)"
      [fullScreen]="true"
      [zIndex]="2000"
    >
    </ngx-spinner>
    <div>
      <div class="d-flex justify-content-between">
        <div>
          <h6 class="dialogue-presentation-source-title m-0">Presentation Source</h6>
          <label class="dialogue-presentation-source-label">Please select source type</label>
        </div>

        <div>
          <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="matDialog.closeAll()">
            <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6 p-3">
          <button nbButton class="presentation-btn w-100" (click)="addPresentationUrl()">
            <img class="youtube-icon" src="assets/icons/Youtube-light.png" alt="" />
            <!-- <mat-icon class="mr-1">play_arrow</mat-icon> YouTube -->
          </button>
        </div>
        <div class="col-md-6 p-3">
          <div class="ion-text-center">
            <span
              style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height: 0px; border: none; margin: 0; padding: 0"
            >
              <input
                type="file"
                name="file"
                accept=".pptx,.pdf,.ppt"
                #fileInput
                (change)="pickFiles($event); isValidSources = true"
                class="inputfile"
              />
            </span>
          </div>

          <button nbButton class="presentation-btn w-100" (click)="fileInput.click()">
            <mat-icon class="mr-1"> insert_drive_file</mat-icon> Document
          </button>
        </div>
      </div>
    </div>
  </div>
  <div>
    <p class="quicksand-normal-label">
      By using API, you agree to comply with the YouTube Terms of Service.
      <a class="youtube-link" href="https://www.youtube.com/t/terms" target="_blank"> Terms and Conditions </a>
      <br /><br />

      Our service does not collect or share any of your data. However, if Google collects any data as part of their services, we recommend
      reviewing their practices. For more details on how Google handles your data, please refer to
      <a class="youtube-link" href="https://policies.google.com/privacy" target="_blank"> Google's Privacy Policy </a>
    </p>
  </div>
</ng-template>

<ng-template #viewYouTubeUrl>
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="text-center">
      <div class="d-flex justify-content-between">
        <div class="text-left">
          <h6 class="dialogue-presentation-source-title m-0">YouTube</h6>
          <label class="dialogue-presentation-source-label">Select from videos or can add custom urls</label>
        </div>

        <div>
          <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="matDialog.closeAll(); tempSelectedVideoUrls = []">
            <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
          </span>
        </div>
      </div>
      <hr />
      <div class="mt-3 you-tube-video-content">
        <form [formGroup]="youtubeUrlForm">
          <div class="row">
            <div class="col-md-12 d-flex justify-content-between custom-youtube-url">
              <div class="form-group w-100 text-left">
                <label class="label form-control-label">Custom YouTube Url</label>
                <input
                  type="text"
                  matInput
                  class="w-100"
                  placeholder="Video Url"
                  formControlName="customYouTubeUrl"
                  [(ngModel)]="customYouTubeUrl"
                />
                <label
                  class="quicksand-bold-label error-label"
                  *ngIf="
                    youtubeUrlForm.controls.customYouTubeUrl.invalid &&
                    (youtubeUrlForm.controls.customYouTubeUrl.dirty || youtubeUrlForm.controls.customYouTubeUrl.touched)
                  "
                >
                  <div *ngIf="youtubeUrlForm.controls.customYouTubeUrl.errors.youtubeUrl">Please enter a valid YouTube URL.</div>
                </label>
              </div>

              <div style="padding-top: 28px">
                <button nbButton class="save-btn ml-3" (click)="addCustomYouTubeUrl()" [disabled]="youtubeUrlForm.invalid">Add</button>
              </div>
            </div>
          </div>
        </form>

        <nb-tabset (changeTab)="onTabChange($event)">
          <nb-tab *ngFor="let section of sectionTitles" [tabTitle]="section" class="p-0">
            <div class="row mt-3">
              <div class="col-md-4 mb-3" *ngFor="let video of addVideoUrlsBySection[section] || []">
                <div
                  class="add-you-tube-content cursor-pointer text-left"
                  [ngClass]="isVideoSelected(video) ? 'border-selected' : ''"
                  (click)="addYouTubeUrl(video); isValidSources = true"
                >
                  <iframe
                    [src]="video"
                    frameborder="0"
                    height="150"
                    style="width: 100%"
                    class="you-tube-video-frame"
                    allowfullscreen
                    referrerpolicy="strict-origin-when-cross-origin"
                    allow="unload"
                  ></iframe>
                </div>
              </div>
            </div>
          </nb-tab>
        </nb-tabset>
      </div>

      <div class="text-right modal-footer-content footer">
        <button nbButton (click)="matDialog.closeAll(); saveSelectedYouTubeUrls()" class="save-you-tube-urls">Save</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #lessonPlanPrivacyDialog let-data let-ref="dialogRef">
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <nb-card class="privacy-option">
      <nb-card-header class="d-flex justify-content-end bg-white">
        <span class="icon-close-classroom-modal d-block cursor-pointer" (click)="ref.close(); privacyOption = 0">
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </nb-card-header>
      <nb-card-body>
        <div class="text-center">
          <label f class="label-delete-lesson-plan quicksand-bold-label mt-1"
            >Please Select Lesson Plan Privacy Option! <span class="required-field">*</span></label
          >
          <br />

          <mat-form-field appearance="outline" class="w-100 mt-3 test-class">
            <mat-label>Select Privacy Option </mat-label>
            <mat-select [(ngModel)]="privacyOption" name="type" [panelClass]="getPanelClass()">
              <mat-option
                class="quicksand-bold-label select-range"
                *ngFor="let privacyOptionsValue of privacyOptions"
                [value]="privacyOptionsValue?.value"
                [disabled]="user?.user?.is_trial_user && privacyOptionsValue.value !== 3 && user.user.is_trial_user"
              >
                {{ privacyOptionsValue?.name | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="quicksand-bold-label text-center mb-3" *ngIf="privacyOption === 1 && this.storageService.getItem('document')">
          By attaching document, you acknowledge that you're sharing it voluntarily. We are not responsible for its privacy or
          confidentiality.
        </div>
        <div class="d-flex">
          <button
            nbButton
            color="warn"
            class="save-changes-btn w-100 quicksand-bold-label"
            [disabled]="!privacyOption"
            (click)="openLessonPlanPrivacyDialog(true)"
          >
            Done
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>

<ng-template #lessonPlanModal let-modal>
  <div class="english-lesson-plan-modal" [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <div class="modal-ai-header border-bottom-0 rounded-left rounded-right">
      <div class="d-flex m-2 align-item-center w-100">
        <div class="d-flex align-item-center justify-content-center w-100">
          <label class="header quicksand-bold-label m-0"> AI-Generated Lesson Based on Literary Choice </label>
        </div>

        <div class="px-3">
          <span
            class="icon-close-classroom-modal d-block cursor-pointer"
            (click)="
              modalService.dismissAll(lessonPlanModal);
              lessonPlanForm.reset();
              analyticsService?.trackEvent('Lesson Plan Modal', 'Classroom Dashboard Lesson Plan')
            "
          >
            <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
          </span>
        </div>
      </div>
      <div *ngFor="let plan of combinedPacingPlans; let i = index">
        <label class="section-number-title quicksand-bold-label">{{ i + 1 }}. {{ plan.section_id }} </label><br />
        <label class="section-title quicksand-bold-label">{{ plan.section_title }}</label>
      </div>
      <hr />
      <label class="section-note quicksand-normal-label">
        Note: Please confirm that the details of this AI-generated lesson plan are correct. If not, click "Cancel" below and try creating it
        once more for a more suitable result. Then, click "Save".
      </label>
      <hr class="m-0" />
    </div>

    <div class="modal-body">
      <div class="d-flex">
        <label class="title quicksand-normal-label"> Title: {{ lessonPlanForm?.value?.title }}</label>
        <label class="title quicksand-normal-label"> Author: {{ lessonPlanForm?.value?.author }}</label>
        <label class="title quicksand-normal-label" *ngIf="lessonPlanForm?.value?.chapter !== ''"
          >Chapter: {{ lessonPlanForm?.value?.chapter }}
        </label>
      </div>
      <div class="lesson-plan-modal">
        <form [formGroup]="englishlessonPlanForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="label form-control-label header-label">Presentation:</label>
                <div class="nb-input">
                  <textarea
                    formControlName="presentation"
                    matInput
                    nbInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    placeholder="Presentation"
                    class="w-100 text-area"
                    mat-autosize="true"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label class="label form-control-label header-label">Guided Practice Questions:</label>

                <div class="nb-input">
                  <textarea
                    formControlName="guided_practice_questions"
                    matInput
                    nbInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    placeholder="Guided Practice Questions"
                    class="w-100 text-area"
                    mat-autosize="true"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label class="label form-control-label header-label">Homework Questions:</label>

                <div class="nb-input">
                  <textarea
                    formControlName="homework_questions"
                    matInput
                    nbInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    placeholder="Homework Questions"
                    class="w-100 text-area"
                    mat-autosize="true"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group">
                <label class="label form-control-label header-label">Closure:</label>

                <div class="nb-input">
                  <textarea
                    nbInput
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    placeholder="Closure"
                    formControlName="closure"
                    class="w-100 text-area"
                    mat-autosize="true"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-end">
      <button
        nbButton
        aria-label="Example icon button with a home icon"
        class="cancel-classroom-btn quicksand-bold-label mr-3 text-capitalize bg-white bg-white-color"
        (click)="modalService.dismissAll(lessonPlanModal); clearEnglishLessonPlan()"
      >
        Cancel
      </button>

      <button
        nbButton
        aria-label="Example icon button with a home icon"
        class="add-classroom-btn add-classroom mr-3 quicksand-bold-label text-capitalize"
        (click)="modalService.dismissAll(lessonPlanModal); generateLessonPlan()"
      >
        Regenerate
      </button>
      <button
        nbButton
        color="warn"
        class="save-changes-btn button quicksand-bold-label"
        (click)="patchEnglishLessonPlanForm(); modalService.dismissAll(lessonPlanModal)"
      >
        Save
      </button>
    </div>
  </div>
</ng-template>
<!-- upload document warning popup -->
<ng-template #uploadedDocument let-data let-ref="dialogRef">
  <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''">
    <nb-card class="upload-document">
      <nb-card-body class="p-3">
        <div class="text-center">
          <img src="/assets/icons/save-featured-icon.svg" class="mb-1" alt="warning-icon" width="80" loading="lazy" />
          <br />
          <h6 class="quicksand-bold-label">Upload Document</h6>

          <label class="quicksand-normal-label">
            By attaching this document, you acknowledge that you're sharing it voluntarily. We are not responsible for its privacy or
            confidentiality.</label
          >
          <br />
        </div>
        <div class="d-flex justify-content-end">
          <label class="okay-text quicksand-bold-label" (click)="ref.close()">Okay</label>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>